import React from 'react';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';

interface RegisteredLegalPersonDetailModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const RegisteredLegalPersonDetailModal: React.FC<RegisteredLegalPersonDetailModalProps> = ({ isOpen, onClose }) => {
    const legalPersonInfo = useSelector((state: RootState) => state.legalPerson);

    const { t } = useTranslation('verification');
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-left text-black">
                <span
                    className="close"
                    onClick={onClose}
                >
                    ×
                </span>
                <h2>{t('detail info')}</h2>
                {legalPersonInfo.selectedIndex !== null && (
                    <div>
                        {/* <p>
                            <strong>{t('reference number')} : </strong>
                            <span>{t(legalPersonInfo.data[legalPersonInfo.selectedIndex].name)}</span>
                        </p>
                        <p>
                            <strong>{t('status')} : </strong>
                            <span>
                                {t(legalPersonInfo.data[legalPersonInfo.selectedIndex].status)}
                            </span>
                        </p>
                        <p>
                            <strong>{t('result')} : </strong>
                            <span>{''}</span>
                        </p>
                        <p>
                            <strong>{t('proceed date')} : </strong>
                            <span>{t(legalPersonInfo.data[legalPersonInfo.selectedIndex].received_date)}</span>
                        </p>
                        <p>
                            <strong>{t('proceed user')} : </strong>
                            <span>{t(legalPersonInfo.data[legalPersonInfo.selectedIndex].proceed_user)}</span>
                        </p>
                        <p>
                            <strong>{t('completed email')} : </strong>
                            <span>{t(legalPersonInfo.data[legalPersonInfo.selectedIndex].completed_email)}</span>
                        </p> */}
                    </div>
                )}
                <div className='flex flex-row justify-start'>
                    <div className='m-[10px]'>
                        <Button
                            label={t('close')}
                            onClick={onClose}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisteredLegalPersonDetailModal;
